import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  editRow: {
    flexWrap: 'nowrap',
    alignItems: 'center'
  },
  // Fixed, compact width so the fullWidth numeric input sits inline with the save/cancel
  // icons instead of stretching the row and pushing them onto the next line.
  inputWrap: {
    width: 68,
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center'
  },
  // The standard TextField's FormControl is taller than its visible input (it reserves space
  // below), which threw off vertical centering against the icons. Collapse it to the input
  // height so the input, save, and cancel all line up on one row.
  input: {
    marginRight: 0,
    height: 36,
    justifyContent: 'center'
  },
  iconButton: {
    flex: '0 0 auto',
    padding: theme.spacing(1)
  },
  icon: {
    width: 18,
    height: 18
  }
}));

export default useStyles;
